module.exports = __webpack_public_path__ + "static/media/add3.3d174c8c.png";